import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, useAuthContext } from './app/providers/AuthProvider';
import { AppRouter } from './app/router';
import Loading from './features/auth/components/Loading';
import AccessDenied from './features/auth/components/AccessDenied';

function AppContent() {
  const { isAuthorized, authMessage } = useAuthContext();

  // Show loading while checking authorization
  if (isAuthorized === null) {
    return <Loading />;
  }

  // Show access denied if not authorized
  if (isAuthorized === false) {
    return <AccessDenied message={authMessage} />;
  }

  // Show app if authorized
  return <AppRouter />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
